import React, { memo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useOverlayState } from '../../../../hooks/useOverlayState';

import EditLineIcon from '../../../../design-system/Icons/EditLineIcon';
import DeleteScenarioModal from '../../DeleteScenarioModal/DeleteScenarioModal';
import { Badge, ButtonIcon, SvgIcon } from '../../../../design-system';
import { DeleteBin4LineIcon, FlowChartIcon } from '../../../../design-system/Icons';

const ScenarioCard = ({ scenario, isEditable, setPlaybookDetail }) => {
    const { id, name, description, is_live } = scenario;

    const navigate = useNavigate();
    const location = useLocation();

    const {
        isOpened: isDeleteModalOpened,
        open: openDeleteModal,
        close: closeDeleteModal,
    } = useOverlayState();

    const renderBadge = () => {
        if (is_live) {
            return <Badge text="LIVE" color="lime" />;
        }
        return <Badge text="DRAFT" color="neutral" />;
    };

    const onScenarioDelete = () => {
        setPlaybookDetail((playbook) => {
            const scenarios = playbook.scenarios?.filter((scenario) => scenario.id !== id);
            return { ...playbook, scenarios };
        });
    };

    return (
        <li className="px-4 py-3 rounded-2 border-1 border-neutral-200 flex flex-col-reverse min-[520px]:flex-row min-[520px]:items-center min-[520px]:justify-between gap-y-2 gap-x-3 md:gap-x-4">
            <div className="overflow-hidden">
                <div className="flex items-start gap-2 mb-0.5">
                    <SvgIcon color="#1F2125" icon={FlowChartIcon} size="medium" />
                    <p className="flex items-center font-body-bold text-body-bold-xs text-black min-h-[16px]">
                        {name}
                    </p>
                </div>

                <p className="font-body text-body-regular-xs text-neutral-500 truncate">
                    {description}
                </p>
            </div>

            <div className="flex items-center justify-between md:justify-end gap-2 lg:gap-4">
                {renderBadge()}

                <div className="flex items-center gap-2 lg:gap-4">
                    <ButtonIcon
                        type="link"
                        size="xs"
                        icon={EditLineIcon}
                        onClick={() =>
                            navigate(`/configure/scenario/${id}`, { state: { from: location } })
                        }
                    />
                    <ButtonIcon
                        type="link"
                        size="xs"
                        state={isEditable ? 'default' : 'disabled'}
                        icon={DeleteBin4LineIcon}
                        onClick={openDeleteModal}
                    />
                </div>
            </div>

            {isDeleteModalOpened && (
                <DeleteScenarioModal
                    id={id}
                    name={name}
                    onScenarioDelete={onScenarioDelete}
                    onClose={closeDeleteModal}
                />
            )}
        </li>
    );
};

export default memo(ScenarioCard);
